export default {
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.list': 'List',
  'menu.profile': 'Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.logout': 'Logout',
  'menu.exception.not-permission.description': 'Sorry, you are not authorized to access this page.',
  'menu.embedTemplate': 'Emebed Template',

  // BEGIN :: Side Menu Translations
  'menu.options': 'Options',
  'menu.processes': 'Processes',
  'menu.processes.details': 'Details',
  'menu.processes.actions': 'Actions',
  'menu.processes.start': 'Start Request',
  'menu.launchpad': 'Launchpad',
  'menu.tasks': 'Tasks',
  'menu.tasks.tasks': 'Tasks',
  'menu.tasks.myDay': 'My Day',
  'menu.tasks.favorites': 'Favorites',
  'menu.tasks.planned': 'Planned',
  'menu.tasks.overdue': 'Overdue',
  'menu.tasks.miscellaneous': 'Miscellaneous',
  'menu.applications': 'Requests',
  'menu.applications.details': 'Request Details',
  'menu.applications.bulkDetails': 'Bulk Task Details',
  'menu.applications.continue': 'Continue',
  'menu.reports': 'Reports',
  'menu.apps': 'Apps',
  'menu.apps.builder': 'App Builder',
  'menu.agents': 'Agents',
  'menu.reports.details': 'Report Details',
  'menu.agents.details': 'Agent Details',
  'menu.agents.builder': 'Agent Builder',
  'menu.renderTemplate': 'Template',
  'menu.administration': 'Administration',
  'menu.connections': 'Connections',
  'menu.connections.api': 'API Connections',
  'menu.connections.database': 'Database Connections',
  'menu.connections.queries': 'Database Queries',
  'menu.connections.callback': 'Callback',
  'menu.documents': 'Documents',
  'menu.projects': 'Projects',
  'menu.projects.project-builder': 'Project builder',
  'menu.entities': 'Entities',
  'menu.entities.groups': 'Groups',
  'menu.entities.byGroup': 'Entities by Group',
  'menu.entities.details': 'Details',
  'menu.entities.manage-entities': 'Manage Entities',
  'menu.entities.entity-builder': 'Entity Builder',
  'menu.configuration': 'Configuration',
  'menu.configuration.users': 'Users',
  'menu.configuration.digital-certificates': 'Digital Certificates',
  'menu.configuration.users-groups': 'User Groups',
  'menu.configuration.process-group': 'Process Groups',
  'menu.configuration.positions': 'Positions',
  'menu.configuration.media': 'Media',
  'menu.configuration.media-categories': 'Media Categories',
  'menu.configuration.approvers': 'Approvers',
  'menu.configuration.approvers.userGroup': 'By Group',
  'menu.configuration.approvers.groupAndPosition': 'By Group and Position',
  'menu.configuration.approvers.entity': 'By Entity',
  'menu.configuration.approvers.entityAndUserGroup': 'By Entity and User Group',
  'menu.configuration.approvers.entityAndPosition': 'By Entity and Position',
  'menu.configuration.approvers.globalUserGroupAndArea': 'By Group and Area',
  'menu.configuration.approvers.globalEntityAndArea': 'By Entity and Area',
  'menu.configuration.email-formats': 'Email Formats',
  'menu.configuration.environments': 'Environments',
  'menu.configuration.process-portal': 'Process Portal',
  'menu.configuration.reports-tokens': 'Report Tokens',
  'menu.configuration.reports': 'Reports',
  'menu.configuration.reports-groups': 'Report Groups',
  'menu.configuration.usage': 'Usage',
  'menu.configuration.aiConsumptions': 'AI Consumptions',
  'menu.configuration.traces': 'Traces',
  'menu.configuration.accessLog': 'Access Logs',
  'menu.configuration.delegations': 'Delegations',
  'menu.configuration.delegations.items': 'Items',
  'menu.configuration.delegations.items.delegatedTasks': 'Delegated Tasks',
  'menu.configuration.areas': 'Areas',
  'menu.configuration.custom-list-groups': 'Custom List Groups',
  'menu.configuration.ai-agent-teams': 'AI Agent Teams',
  'menu.configuration.ai-skill-groups': 'AI Skill Groups',
  'menu.configuration.dynamic-entity-groups': 'Dynamic Entity Groups',
  'menu.configuration.connection-group': 'Connection Groups',
  'menu.configuration.servers': 'Servers',
  'menu.configuration.power-bi-server': 'Power BI',
  'menu.configuration.shortenedUrl': 'Shortened URLs',
  'menu.configuration.sequence': 'Sequences',
  'menu.configuration.administration': 'Administration',
  'menu.configuration.email-traces': 'Email Traces',
  'menu.configuration.teams-message-traces': 'Teams Traces',
  'menu.configuration.sms-message-traces': 'SMS Traces',
  'menu.configuration.extra-user-fields': 'Extra User Fields',
  'menu.configuration.user-devices': 'Devices',
  'menu.configuration.notificationTemplates': 'Notification Templates',
  'menu.processes.config': 'Configure Process',
  'menu.connections.groups': 'Groups',
  'menu.connections.connections': 'Connections',
  'menu.lists': 'Lists',
  'menu.lists.groups': 'Groups',
  'menu.lists.byGroup': 'By Group',
  'menu.lists.details': 'Details',
  'menu.lists.list-builder': 'List Builder',
  'menu.lists.details-classic': 'Details',
  'menu.user-management': 'User Management',
  'menu.media': 'Media',
  'menu.mediaAssets': 'Media Assets',
  'menu.lists-dynamic-entities': 'Lists and Dynamic Entities',
  'menu.integration-connections': 'Integration and Connections',
  'menu.check-auditory': 'Tracking and Auditing',
  'menu.support': 'Support',
  'menu.security': 'Security',
  'menu.organization': 'Organization',
  'menu.configuration.access-policies': 'Access Policies',
  'menu.configuration.security-events': 'SIEM',
  'menu.configuration.security-events.tooltip': 'Security Information and Event Management',
  'menu.configuration.ai-billing': 'AI Billing',
  'menu.configuration.custom-domains': 'Custom Domains',
  'menu.configuration.white-label': 'White Label',
  'menu.configuration.channel-customers': 'Customers',
  'menu.configuration.channel-registration-approvals': 'Registration requests',
  'menu.configuration.billing-subscription-payments': 'Subscription payments',
  'menu.configuration.financial-administration': 'Financial administration',
  'menu.configurations': 'Configurations',
  'menu.filter.result': '({number}) Results',
  // END :: Side Menu Translations
};
